import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ShopperSocialGroupJoinScanPage } from "./../shopper-social-group-join-scan/shopper-social-group-join-scan";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-social-group-join",
  templateUrl: "shopper-social-group-join.html",
})
export class ShopperSocialGroupJoinPage {
  lists: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaList;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.lists = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  select(id) {
    this.navCtrl.push(ShopperSocialGroupJoinScanPage, { plaza_id: id });
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-join/shopper-social-group-join.ts